import Button from "react-bootstrap/Button";
import {
  Clipboard,
  HandThumbsUp,
  HandThumbsDown,
  ArrowRepeat,
} from "react-bootstrap-icons";

export default function MessageActions({
  messageId,
  feedback,
  onCopy,
  onFeedback,
  onRetry,
}) {
  
  return (
    <div className="jacai-message-actions d-flex align-items-center gap-2">
      {onCopy && (
        <Button
          variant="link"
          size="sm"
          className="p-0 jacai-action-btn"
          onClick={() => onCopy(messageId)}
          title="Copy"
        >
          <Clipboard />
        </Button>
      )}

      {onFeedback && (
        <>
          <Button
            variant="link"
            size="sm"
            className="p-0 jacai-action-btn"
            onClick={() => onFeedback(messageId, true)}
            title="Like"
          >
            <HandThumbsUp
              style={{
                color: feedback === "up" ? "#0d6efd" : "inherit",
              }}
            />
          </Button>

          <Button
            variant="link"
            size="sm"
            className="p-0 jacai-action-btn"
            onClick={() => onFeedback(messageId, false)}
            title="Dislike"
          >
            <HandThumbsDown
              style={{
                color: feedback === "down" ? "#dc3545" : "inherit",
              }}
            />
          </Button>
        </>
      )}

      {onRetry && (
        <Button
          variant="link"
          size="sm"
          className="p-0 jacai-action-btn"
          onClick={() => onRetry(messageId)}
          title="Retry"
        >
          <ArrowRepeat />
        </Button>
      )}
    </div>
  );
}